import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBreadcrumbArrow = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		opacity: .5,
		children: /* @__PURE__ */ _jsx("path", {
			d: "M9 18.5898L14.2929 13.297C14.6834 12.9064 14.6834 12.2733 14.2929 11.8827L9 6.58984",
			stroke: "#2B313A",
			strokeWidth: 1.5
		})
	})
});
export default SvgBreadcrumbArrow;
